import React, { createContext, useState, useContext } from "react";

export const SearchContext = createContext();

export const SearchProvider = ({ children }) => {
  const [globalSearchResult, setGlobalSearchResult] = useState(null);

  return (
    <SearchContext.Provider value={{ globalSearchResult, setGlobalSearchResult }}>
      {children}
    </SearchContext.Provider>
  );
};

export const useGlobalSearch = () => useContext(SearchContext);
